// https://www.builder.io/c/docs/using-your-api-key
export const environment = {
  production: false,
  baseUrl: 'http://32.195.37.209:58107/api',
  appOrigin: '',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.lumina.app',
  appStoreUrl: 'https://apps.apple.com/app/lumina/id0000000000',
  emailjs: {
    publicKey: 'gJXcONDOOBMNvBgoS',
    serviceId: 'service_yfd8k5n',
    templateId: 'template_lc7pezo',
  },
};
